import { ButtonDropdown } from "@frends/ui-components/react";

export default ButtonDropdown;
